export enum ProductType {
  singleTicket = 1,
  prepaidTicket = 4,
  periodTicket = 5,
  dayTicket = 6,
  flexTicket = 9,
  partialYearTicket = 10,
}
